import api from './api';

export const customerService = {
  // Get all customers with pagination and filtering
  getCustomers: async (params = {}) => {
    const response = await api.get('/v1/customers/customers/', { params });
    return response.data;
  },

  // Get a single customer by ID
  getCustomer: async (id) => {
    const response = await api.get(`/v1/customers/customers/${id}/`);
    return response.data;
  },

  // Create a new customer
  createCustomer: async (customerData) => {
    const response = await api.post('/v1/customers/customers/', customerData);
    return response.data;
  },

  // Update an existing customer
  updateCustomer: async (id, customerData) => {
    const response = await api.put(`/v1/customers/customers/${id}/`, customerData);
    return response.data;
  },

  // Delete a customer
  deleteCustomer: async (id) => {
    const response = await api.delete(`/v1/customers/customers/${id}/`);
    return response.data;
  },

  // Get customer statistics
  getCustomerStats: async () => {
    const response = await api.get('/v1/customers/customers/stats/');
    return response.data;
  },

  // Get vehicles for a customer
  getCustomerVehicles: async (customerId) => {
    const response = await api.get(`/v1/customers/customers/${customerId}/vehicles/`);
    return response.data;
  },

  // Add a vehicle to a customer
  addCustomerVehicle: async (customerId, vehicleData) => {
    const response = await api.post(`/v1/customers/customers/${customerId}/add_vehicle/`, vehicleData);
    return response.data;
  },

  // Vehicle CRUD operations
  getVehicles: async (params = {}) => {
    const response = await api.get('/v1/customers/vehicles/', { params });
    return response.data;
  },

  getVehicle: async (id) => {
    const response = await api.get(`/v1/customers/vehicles/${id}/`);
    return response.data;
  },

  updateVehicle: async (id, vehicleData) => {
    const response = await api.put(`/v1/customers/vehicles/${id}/`, vehicleData);
    return response.data;
  },

  deleteVehicle: async (id) => {
    const response = await api.delete(`/v1/customers/vehicles/${id}/`);
    return response.data;
  },
};